export interface WorkCostBareme {
  category: string;
  equipment_name: string;
  pricing_type: 'per_sqm' | 'fixed';
  price_per_sqm?: number;
  fixed_price?: number;
  is_breathable?: boolean;
  notes?: string;
}

export const WORK_COSTS_DATABASE: WorkCostBareme[] = [
  {
    category: 'windows',
    equipment_name: 'Double vitrage standard',
    pricing_type: 'per_sqm',
    price_per_sqm: 450,
    notes: 'Fenêtre PVC double vitrage Uw=1.3, fourniture et pose',
  },
  {
    category: 'windows',
    equipment_name: 'Double vitrage performant',
    pricing_type: 'per_sqm',
    price_per_sqm: 550,
    notes: 'Fenêtre PVC double vitrage renforcé Uw=1.1, fourniture et pose',
  },
  {
    category: 'windows',
    equipment_name: 'Triple vitrage',
    pricing_type: 'per_sqm',
    price_per_sqm: 700,
    notes: 'Fenêtre PVC triple vitrage Uw=0.8, fourniture et pose',
  },
  {
    category: 'windows',
    equipment_name: 'Double vitrage ancien',
    pricing_type: 'per_sqm',
    price_per_sqm: 0,
    notes: 'Déjà installé, pas de remplacement',
  },
  {
    category: 'windows',
    equipment_name: 'Simple vitrage',
    pricing_type: 'per_sqm',
    price_per_sqm: 0,
    notes: 'Déjà installé, pas de remplacement',
  },
  {
    category: 'wall_insulation',
    equipment_name: 'ITE Isolation 100mm',
    pricing_type: 'per_sqm',
    price_per_sqm: 140,
    is_breathable: false,
    notes: 'Isolation thermique par l\'extérieur polystyrène, toutes épaisseurs',
  },
  {
    category: 'wall_insulation',
    equipment_name: 'ITE Isolation 140mm',
    pricing_type: 'per_sqm',
    price_per_sqm: 140,
    is_breathable: false,
    notes: 'Isolation thermique par l\'extérieur polystyrène, toutes épaisseurs',
  },
  {
    category: 'wall_insulation',
    equipment_name: 'ITE Isolation 200mm',
    pricing_type: 'per_sqm',
    price_per_sqm: 140,
    is_breathable: false,
    notes: 'Isolation thermique par l\'extérieur polystyrène, toutes épaisseurs',
  },
  {
    category: 'wall_insulation',
    equipment_name: 'ITE 140mm laine de roche',
    pricing_type: 'per_sqm',
    price_per_sqm: 150,
    is_breathable: true,
    notes: 'Isolation thermique par l\'extérieur laine de roche 140mm - Matériau perspirant',
  },
  {
    category: 'wall_insulation',
    equipment_name: 'ITE 160mm fibre de bois',
    pricing_type: 'per_sqm',
    price_per_sqm: 160,
    is_breathable: true,
    notes: 'Isolation thermique par l\'extérieur fibre de bois 160mm - Matériau biosourcé perspirant',
  },
  {
    category: 'wall_insulation',
    equipment_name: 'ITI 50mm polyuréthane',
    pricing_type: 'per_sqm',
    price_per_sqm: 90,
    is_breathable: false,
    notes: 'ITI polyuréthane 50mm : isolant, ossature métallique, placo BA13, bandes joints et finition, pose par artisan RGE',
  },
  {
    category: 'wall_insulation',
    equipment_name: 'ITI 80mm polyuréthane',
    pricing_type: 'per_sqm',
    price_per_sqm: 100,
    is_breathable: false,
    notes: 'ITI polyuréthane 80mm : isolant, ossature métallique, placo BA13, bandes joints et finition, pose par artisan RGE',
  },
  {
    category: 'wall_insulation',
    equipment_name: 'ITI 80mm laine de verre/bois',
    pricing_type: 'per_sqm',
    price_per_sqm: 80,
    is_breathable: true,
    notes: 'ITI laine minérale 80mm perspirant : isolant, ossature métallique, placo BA13, bandes joints et finition, pose par artisan RGE',
  },
  {
    category: 'wall_insulation',
    equipment_name: 'ITI 100mm laine de roche',
    pricing_type: 'per_sqm',
    price_per_sqm: 85,
    is_breathable: true,
    notes: 'ITI laine de roche 100mm perspirant : isolant, ossature métallique, placo BA13, bandes joints et finition, pose par artisan RGE',
  },
  {
    category: 'wall_insulation',
    equipment_name: 'ITI 120mm laine de verre/bois',
    pricing_type: 'per_sqm',
    price_per_sqm: 95,
    is_breathable: true,
    notes: 'ITI laine minérale 120mm perspirant : isolant, ossature métallique, placo BA13, bandes joints et finition, pose par artisan RGE',
  },
  {
    category: 'wall_insulation',
    equipment_name: 'ITI 50mm liège',
    pricing_type: 'per_sqm',
    price_per_sqm: 115,
    is_breathable: true,
    notes: 'ITI liège expansé 50mm perspirant : isolant, ossature métallique, placo BA13, bandes joints et finition, pose par artisan RGE',
  },
  {
    category: 'roof_insulation',
    equipment_name: 'Isolation combles perdus 200mm',
    pricing_type: 'per_sqm',
    price_per_sqm: 35,
    notes: 'Isolation combles perdus par soufflage 200mm (R=5.0), fourniture et pose',
  },
  {
    category: 'roof_insulation',
    equipment_name: 'Isolation combles perdus 300mm',
    pricing_type: 'per_sqm',
    price_per_sqm: 45,
    notes: 'Isolation combles perdus par soufflage 300mm (R=7.5), fourniture et pose',
  },
  {
    category: 'roof_insulation',
    equipment_name: 'Isolation combles perdus 400mm',
    pricing_type: 'per_sqm',
    price_per_sqm: 55,
    notes: 'Isolation combles perdus par soufflage 400mm (R=10.0), fourniture et pose',
  },
  {
    category: 'roof_insulation',
    equipment_name: 'Isolation rampants 200mm laine minérale',
    pricing_type: 'per_sqm',
    price_per_sqm: 55,
    notes: 'Isolation sous rampants combles aménagés 200mm (R=5.0) : isolant, ossature, placo BA13, bandes joints et finition, pose par artisan RGE',
  },
  {
    category: 'roof_insulation',
    equipment_name: 'Isolation rampants 300mm laine minérale',
    pricing_type: 'per_sqm',
    price_per_sqm: 65,
    notes: 'Isolation sous rampants combles aménagés 300mm (R=7.5) : isolant, ossature, placo BA13, bandes joints et finition, pose par artisan RGE',
  },
  {
    category: 'roof_insulation',
    equipment_name: 'Isolation rampants 400mm laine minérale',
    pricing_type: 'per_sqm',
    price_per_sqm: 75,
    notes: 'Isolation sous rampants combles aménagés 400mm (R=10.0) : isolant, ossature, placo BA13, bandes joints et finition, pose par artisan RGE',
  },
  {
    category: 'roof_insulation',
    equipment_name: 'Toiture-terrasse 120mm polyuréthane/PIR',
    pricing_type: 'per_sqm',
    price_per_sqm: 150,
    notes: 'Isolation toiture-terrasse par l\'extérieur avec panneaux polyuréthane/PIR 120mm. Inclut pose, fixation mécanique et étanchéité bitume bicouche. R=5.5 m².K/W',
  },
  {
    category: 'roof_insulation',
    equipment_name: 'Toiture-terrasse 200mm laine de roche',
    pricing_type: 'per_sqm',
    price_per_sqm: 180,
    notes: 'Isolation toiture-terrasse par l\'extérieur avec panneaux laine de roche haute densité 200mm. Inclut pose, pare-vapeur et étanchéité EPDM. R=5.5 m².K/W',
  },
  {
    category: 'floor_insulation',
    equipment_name: 'Isolation plancher 100mm',
    pricing_type: 'per_sqm',
    price_per_sqm: 50,
    notes: 'Isolation plancher bas 100mm R=2.5, fourniture et pose',
  },
  {
    category: 'floor_insulation',
    equipment_name: 'Isolation plancher 120mm',
    pricing_type: 'per_sqm',
    price_per_sqm: 60,
    notes: 'Isolation plancher bas 120mm R=3.0, fourniture et pose',
  },
  {
    category: 'floor_insulation',
    equipment_name: 'Isolation plancher 160mm',
    pricing_type: 'per_sqm',
    price_per_sqm: 75,
    notes: 'Isolation plancher bas 160mm R=4.0, fourniture et pose',
  },
  {
    category: 'heating',
    equipment_name: 'Pompe à chaleur air-eau',
    pricing_type: 'fixed',
    fixed_price: 19500,
    notes: 'PAC air-eau moyenne gamme, fourniture et pose (fourchette 17000-22000€)',
  },
  {
    category: 'heating',
    equipment_name: 'Pompe à chaleur air-air',
    pricing_type: 'fixed',
    fixed_price: 9000,
    notes: 'PAC air-air multi-split, fourniture et pose',
  },
  {
    category: 'heating',
    equipment_name: 'Chaudière gaz condensation',
    pricing_type: 'fixed',
    fixed_price: 5500,
    notes: 'Chaudière gaz à condensation murale, fourniture et pose',
  },
  {
    category: 'heating',
    equipment_name: 'Chaudière bois',
    pricing_type: 'fixed',
    fixed_price: 14000,
    notes: 'Chaudière à granulés de bois, fourniture et pose',
  },
  {
    category: 'heating',
    equipment_name: 'Radiateurs électriques',
    pricing_type: 'fixed',
    fixed_price: 3500,
    notes: 'Remplacement complet radiateurs électriques, fourniture et pose',
  },
  {
    category: 'hot_water',
    equipment_name: 'Chauffe-eau thermodynamique',
    pricing_type: 'fixed',
    fixed_price: 3200,
    notes: 'Ballon thermodynamique 250L, fourniture et pose',
  },
  {
    category: 'hot_water',
    equipment_name: 'Ballon électrique 150L',
    pricing_type: 'fixed',
    fixed_price: 1000,
    notes: 'Ballon électrique à accumulation 150L, fourniture et pose',
  },
  {
    category: 'hot_water',
    equipment_name: 'Ballon électrique 200L',
    pricing_type: 'fixed',
    fixed_price: 1200,
    notes: 'Ballon électrique à accumulation 200L, fourniture et pose',
  },
  {
    category: 'hot_water',
    equipment_name: 'Ballon électrique 300L',
    pricing_type: 'fixed',
    fixed_price: 1500,
    notes: 'Ballon électrique à accumulation 300L, fourniture et pose',
  },
  {
    category: 'hot_water',
    equipment_name: 'Chauffe-eau gaz',
    pricing_type: 'fixed',
    fixed_price: 1800,
    notes: 'Chauffe-eau gaz instantané, fourniture et pose',
  },
  {
    category: 'hot_water',
    equipment_name: 'Chauffe-eau semi-instantané 40L',
    pricing_type: 'fixed',
    fixed_price: 800,
    notes: 'Chauffe-eau semi-instantané, fourniture et pose',
  },
  {
    category: 'hot_water',
    equipment_name: 'Chauffe-eau semi-instantané 50L',
    pricing_type: 'fixed',
    fixed_price: 800,
    notes: 'Chauffe-eau semi-instantané, fourniture et pose',
  },
  {
    category: 'hot_water',
    equipment_name: 'Chauffe-eau semi-instantané 65L',
    pricing_type: 'fixed',
    fixed_price: 800,
    notes: 'Chauffe-eau semi-instantané, fourniture et pose',
  },
  {
    category: 'hot_water',
    equipment_name: 'Chauffe-eau semi-instantané 75L',
    pricing_type: 'fixed',
    fixed_price: 800,
    notes: 'Chauffe-eau semi-instantané, fourniture et pose',
  },
  {
    category: 'hot_water',
    equipment_name: 'Chauffe-eau semi-instantané 80L',
    pricing_type: 'fixed',
    fixed_price: 800,
    notes: 'Chauffe-eau semi-instantané, fourniture et pose',
  },
  {
    category: 'hot_water',
    equipment_name: 'Chauffe-eau semi-instantané 100L',
    pricing_type: 'fixed',
    fixed_price: 800,
    notes: 'Chauffe-eau semi-instantané, fourniture et pose',
  },
  {
    category: 'hot_water',
    equipment_name: 'Chauffe-eau semi-instantané 150L',
    pricing_type: 'fixed',
    fixed_price: 800,
    notes: 'Chauffe-eau semi-instantané, fourniture et pose',
  },
  {
    category: 'ventilation',
    equipment_name: 'VMC simple flux',
    pricing_type: 'fixed',
    fixed_price: 1800,
    notes: 'VMC simple flux autoréglable, fourniture et pose complète',
  },
  {
    category: 'ventilation',
    equipment_name: 'VMC simple flux hygro',
    pricing_type: 'fixed',
    fixed_price: 1800,
    notes: 'VMC simple flux hygroréglable, fourniture et pose complète',
  },
  {
    category: 'ventilation',
    equipment_name: 'VMC double flux',
    pricing_type: 'fixed',
    fixed_price: 5000,
    notes: 'VMC double flux avec récupération de chaleur, fourniture et pose complète',
  },
  {
    category: 'heating_control',
    equipment_name: 'Thermostats d\'ambiance programmables',
    pricing_type: 'fixed',
    fixed_price: 600,
    notes: 'Thermostats programmables, fourniture et installation',
  },
  {
    category: 'heating_control',
    equipment_name: 'Thermostats connectés',
    pricing_type: 'fixed',
    fixed_price: 900,
    notes: 'Thermostats connectés intelligents, fourniture et installation',
  },
  {
    category: 'heating_control',
    equipment_name: 'Régulation par pièce',
    pricing_type: 'fixed',
    fixed_price: 1400,
    notes: 'Système de régulation multi-zones, fourniture et installation',
  },
];

export function getCostForEquipment(
  equipment_name: string,
  category: string
): { pricing_type: 'per_sqm' | 'fixed'; price: number } | null {
  const bareme = WORK_COSTS_DATABASE.find(
    (item) => item.equipment_name === equipment_name && item.category === category
  );

  if (!bareme) {
    return null;
  }

  if (bareme.pricing_type === 'per_sqm' && bareme.price_per_sqm !== undefined) {
    return {
      pricing_type: 'per_sqm',
      price: bareme.price_per_sqm,
    };
  }

  if (bareme.pricing_type === 'fixed' && bareme.fixed_price !== undefined) {
    return {
      pricing_type: 'fixed',
      price: bareme.fixed_price,
    };
  }

  return null;
}
